"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProfileMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class PaymentProfileMapper {
    toDomain(result) {
        const isGuestRefillAllowedLoading = lodash_1.default.get(result, "loading");
        const isGuestAnomyn = lodash_1.default.get(result, "data.getUser.id");
        const managementMode = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.managementMode");
        return {
            isGuestRefillAllowedLoading,
            isGuestAnomyn,
            managementMode,
        };
    }
}
exports.PaymentProfileMapper = PaymentProfileMapper;
